"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsCreateFeatureCollectionMutation = void 0;
const useModelsMutation_1 = require("./useModelsMutation");
function useModelsCreateFeatureCollectionMutation(accountNumber) {
    return useModelsMutation_1.useModelsMutation(accountNumber, 'POST', `/feature-collections`);
}
exports.useModelsCreateFeatureCollectionMutation = useModelsCreateFeatureCollectionMutation;
//# sourceMappingURL=useModelsCreateFeatureCollectionMutation.js.map